import { tailwindColors } from '@repo/tailwind-config/tailwind.vars'
import { useBreakPoint } from '@repo/toolkit/use-break-point'
import {
  LoginGroupFiveIcon,
  LoginGroupFourIcon,
  LoginGroupOneIcon,
  LoginGroupSixIcon,
  LoginGroupThreeIcon,
  LoginGroupTwoIcon
} from '@repo/ui/icons'
import Typography from '@repo/ui/typography'
import { Fragment } from 'react'

interface DefaultAuthVariantProps {
  text: string
}

const DefaultAuthVariant = ({ text }: DefaultAuthVariantProps) => {
  const device = useBreakPoint()
  const isMobile = device === 'mobile'

  return (
    <Fragment>
      <div className="absolute -left-32 bottom-0 w-[250px] mobile:hidden">
        <LoginGroupOneIcon
          color1={tailwindColors.primary.dark.DEFAULT}
          color2={tailwindColors.secondary.DEFAULT}
        />
      </div>
      <div className="absolute right-0 bottom-0 w-[250px] mobile:hidden">
        <LoginGroupFourIcon
          color1={tailwindColors.primary.dark.DEFAULT}
          color2={tailwindColors.secondary.DEFAULT}
        />
      </div>
      <div className="absolute top-0 -right-7 w-[280px] mobile:hidden">
        <LoginGroupTwoIcon
          color1={tailwindColors.primary.dark.DEFAULT}
          color2={tailwindColors.primary.hover}
          color3={tailwindColors.secondary.DEFAULT}
        />
        <LoginGroupThreeIcon
          color1={tailwindColors.primary.dark.DEFAULT}
          color3={tailwindColors.secondary.DEFAULT}
          color2={tailwindColors.primary.hover}
        />
      </div>
      <img src="/logo.png" className="w-20 mt-9 mobile:hidden mx-9 " />

      <div className="absolute top-[123px] left-0 w-[200px] mobile:top-8 mobile:-left-2">
        <LoginGroupFiveIcon color={tailwindColors.secondary.DEFAULT} />
      </div>

      <div className="absolute -bottom-3  right-0  hidden mobile:flex">
        <LoginGroupSixIcon
          color1={tailwindColors.secondary.DEFAULT}
          color3={tailwindColors.primary.DEFAULT}
          color2={tailwindColors.primary.hover}
        />
      </div>

      <div className="absolute top-52 left-16 mobile:top-32 mobile:left-5 ">
        <Typography variant={isMobile ? 'h3' : 'h1'} className="text-white">
          {text.split('\n').map((text, index) => (
            <span key={index}>
              {text}
              <br />
            </span>
          ))}
        </Typography>
      </div>
    </Fragment>
  )
}

export default DefaultAuthVariant
